<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <div class="my-4 display-1">Zaboravljena lozinka</div>
        <v-form v-on:submit.prevent="requestResetPassword">
          <v-text-field v-model="email" label="email" required autocomplete="email" ref="email"></v-text-field>
          <v-btn class="primary" large block type="submit" :loading="loading">Reset</v-btn>
          <v-btn class="secondary" large block to="/login">login</v-btn>
          <v-alert v-if="info" :value="true" type="info" v-text="info"></v-alert>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import auth from '@/services/authService.js'

export default {
  data () {
    return {
      email: '',
      loading: false,
      info: ''
    }
  },
  created () {
    this.$nextTick(() => this.$refs.email.focus())
  },
  methods: {
    requestResetPassword () {
      const vm = this
      this.loading = true
      auth.requestResetPassword(vm.email.trim().toLowerCase(), function (result) {
        vm.loading = false
        vm.info = 'Na datu adresu je poslat email sa linkom koji je potrebno otvoriti da bi se resetovala lozinka'
      }, function (err) {
        console.log(err)
        vm.loading = false
        vm.info = 'Na datu adresu je poslat email sa linkom koji je potrebno otvoriti da bi se resetovala lozinka'
      })
    }
  }
}

</script>

<style scoped>
</style>
